import React from 'react';
import TheMassSendPage from '../components/TheMassSendPage';
import PageHeader from '../components/PageHeader';
import Container from '../components/Container';
import config from '../config';
import { NextSeo } from 'next-seo';

const MassSend = () => {
  const description = `Send any number of Algorand ASAs at once.`;

  return (
    <>
      <NextSeo title={`Mass Send - ${config.siteName}`} description={description} />

      <div className='pb-12 md:pb-48 bg-bg'>
        <PageHeader heading={'Mass Send'} description={description} docsLink='https://docs.shittykitties.art/website-utilities/mass-send' />
        <Container>
          <TheMassSendPage />
        </Container>
      </div>
    </>
  );
};

export default MassSend;
